export function createUUID(): string {
	if (import.meta.env.SSR) {
		return '00000000-0000-0000-0000-000000000000';
	}

	return window.crypto.randomUUID();
}
